import { Section } from "anketa-core/group";
import { Translation } from "anketa-core/i18n";
import { setupProxmoxGroup } from "./proxmox";

const ProxmoxSetupEn = await fetch(require("./tutorial/setup/en.md")).then(
  (res) => res.text()
);
const ProxmoxSetupDe = await fetch(require("./tutorial/setup/de.md")).then(
  (res) => res.text()
);

// Fresh section per catalog build - see network/section.ts for the rationale.
export const proxmoxScanners = (): Section => {
  const proxmoxScanners = new Section("proxmox_scanner", [
    new Translation("en", "Proxmox Scanners"),
    new Translation("en", "Proxmox-Scanner"),
  ]);
  proxmoxScanners.help = [
    new Translation(
      "en",
      `Add Proxmox to get more detailed information about their API!`
    ),
    new Translation(
      "de",
      `Fügen Sie Proxmox hinzu, um detailliertere Informationen über deren API zu erhalten!`
    ),
  ];
  proxmoxScanners.description = [
    new Translation("en", ProxmoxSetupEn),
    new Translation("de", ProxmoxSetupDe),
  ];

  setupProxmoxGroup(proxmoxScanners, 0);
  return proxmoxScanners;
};
